module.exports = __webpack_public_path__ + "img/DSCF7587-Edit-2.398b1826.398b1826.jpg";